import { IRcaState } from "./IRcaState";
import { initialState as proofOfWork } from "../features/proofOfWork/proofOfWorkSlice";
import { initialState as testSelection } from "../features/testSelection/testSelectionSlice";
import { initialState as settings } from "../features/settings/settingsSlice";
import { initialState as oauth } from "../features/oauth/oauthSlice";

const initialState: IRcaState = {
  globalConfig: {
    antiForgeryToken: "",
    language: "",
    langDir: "ltr",
    binaryVersion: "",
    appVersion: "",
    feedbackEmail: "",
    showNav: false,
    hipScenarioId: 0,
    hipClientHost: "",
    hipType: "",
    autoFillEnabled: false,
    themeName: "classic",
    cookieConsentRequired: false,
    bannersDismissed: {},
  },
  testSelection,
  settings,
  testResult: {
    loadInProgress: false,
    currentResult: null,
    progressMessage: "",
    resultLoadErrorReason: "",
    downloadHtmlUrl: "",
    downloadXmlUrl: "",
  },
  testInput: {
    currentInputForm: null,
    formData: {},
    serverValidationErrors: [],
    executeError: "",
    userNameHint: "",
    focusedFieldId: "",
  },
  proofOfWork,
  oauth,
};

export default initialState;
